import type { User } from "@/model/user";

export const getLoggedInUser = async (): Promise<User> => {
  const url = `/api/user`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getLoggedInUser exception: ${error}`);
    throw error;
  }
};

export const getUser = async (phoneNumber: string): Promise<User> => {
  const url = `/api/user/${phoneNumber}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getUser exception: ${error}`);
    throw error;
  }
};

export const getCorporateUsers = async (
  externalId: string,
): Promise<User[]> => {
  const url = `/api/corporate-users/${externalId}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getCorporateUsers exception: ${error}`);
    throw error;
  }
};
